import React from 'react';
import ChartSnapshotConfigManager from '../components/ChartSnapshotConfigManager'; // Import the manager
import PageBackButton from '../components/PageBackButton';

const ChartSnapshotConfigsPage = () => {
  return (
    <div className="p-4 md:p-6 lg:p-8">
      <div className="mb-4">
        <PageBackButton label="Back to Settings" to="/settings" preferHistory={false} hideLabelOnMobile />
      </div>
      <h1 className="text-2xl md:text-3xl font-bold text-textPrimary mb-6">
        Manage Chart Snapshot Configurations
      </h1>
      <p className="text-textSecondary mb-4">
        Here you can create, view, edit, and delete your saved chart snapshot configurations.
      </p>
      <ChartSnapshotConfigManager />
    </div>
  );
};

export default ChartSnapshotConfigsPage;
